export const EsgDataApprovalTableHeaders = [
  'modules.dataManagement.esgValueApproval.kpi',
  'modules.dataManagement.esgValueApproval.currentValue',
  'modules.dataManagement.esgValueApproval.newValue',
  'modules.dataManagement.esgValueApproval.status',
];
